import { Fragment } from "react";

import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "~/components/ui/breadcrumb";

export function Breadcrumbs({
    breadcrumbs,
    className,
}: {
    className?: string;
    breadcrumbs: { href: string; title: string }[];
}) {
    return (
        <Breadcrumb className={className}>
            <BreadcrumbList>
                {breadcrumbs.map(({ href, title }, index) => {
                    const isLast = index === breadcrumbs.length - 1;
                    return (
                        <Fragment key={`${index}:${href}`}>
                            <BreadcrumbItem>
                                {isLast ? (
                                    <BreadcrumbPage>{title}</BreadcrumbPage>
                                ) : (
                                    <BreadcrumbLink href={href}>{title}</BreadcrumbLink>
                                )}
                            </BreadcrumbItem>
                            {isLast ? null : <BreadcrumbSeparator />}
                        </Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
}
